var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay is-overlay",class:{ 'is-opaque': !_vm.transparent }},[_c('div',{staticClass:"overlay-loader",class:_vm.loaderSize,style:(_vm.overlayColor)})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29a8c2a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/enso/bulma/Overlay.vue
// module id = 1BRA
// module chunks = 8 25 49 50 53 66